import React from 'react'

import { useTranslation } from '@platform/i18n/hooks/useTranslation'

import { useEnterWorkspace, useWorkspaces } from '../hooks/useWorkspaces'
import { currentWorkspaceOf } from '../services/workspaces.service'

/** Persistent, subtle reminder that the session is inside a client's books. */
export const WorkspaceBanner: React.FC = () => {
  const { t } = useTranslation('common')
  const { data } = useWorkspaces()
  const { enter, isEntering } = useEnterWorkspace()

  const current = currentWorkspaceOf(data)
  const own = data?.workspaces.find((w) => w.kind === 'own')
  if (!current || current.kind === 'own') return null

  const role = t(`workspaces.roles.${current.role}`, {
    defaultValue: current.role,
  })

  return (
    <div
      role="status"
      data-testid="workspace-banner"
      className="flex items-center justify-center gap-3 px-4 py-2 text-xs bg-crypto-accent/10 border-b border-crypto-accent/30 text-crypto-text"
    >
      <span>{t('workspaces.banner', { name: current.name, role })}</span>
      {own && (
        <button
          type="button"
          disabled={isEntering}
          onClick={() => enter(own.tenantId)}
          data-testid="workspace-banner-back"
          className="underline text-crypto-accent hover:opacity-80 disabled:opacity-50"
        >
          {t('workspaces.back')}
        </button>
      )}
    </div>
  )
}
